module.exports = "/images/deleted_team.png?7319a3f3e7c0189a7779e8119c6bb182";